import ReactDom from 'react-dom';
import { ThemeProvider } from 'styled-components';
import 'normalize.css';
import 'assets/styles.css';
import { theme } from './theme';
import { App } from './app';
// import AuthProvider from './auth-provider';

ReactDom.render(
  <ThemeProvider theme={theme}>
    {/* <AuthProvider> */}
    <App />
    {/* </AuthProvider> */}
  </ThemeProvider>,

  document.getElementById('root')
);
